import React from 'react'
import _cx from 'classnames/bind'
import PropTypes from 'prop-types'
import { Text } from '@adc/ui-adc'
import { Duration } from 'common/modules/bidBanner/auctionDuration'
import cls from './styles.scss'
const cx = _cx.bind(cls)

const TimeInformation = ({ segment }) => {
  const { initial_end_date: endDateTime, start_date: startDateTime } =
    segment || {}
  return (
    <div className={cx('container')} data-elm-id='time_information'>
      <div className={cx('duration-container')}>
        <Text
          className='u-mr-2'
          color='grayMedium'
          data-elm-id='auction_duration_label'
        >
          Auction Duration
        </Text>
        <Duration
          endDateTime={endDateTime}
          fontWeight='normal'
          startDateTime={startDateTime}
        />
      </div>
    </div>
  )
}

TimeInformation.propTypes = {
  segment: PropTypes.object,
}

export default TimeInformation
